import React, { useEffect, useState } from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { fetchPartnerById, fetchPartnersRequest } from '../../api/partners/partnerSlice';
import { useDispatch, useSelector } from 'react-redux';

const PartnersSelectField = ({ initialValue, onChange }) => {
  const { partners, totalCount } = useSelector((state) => state.partners);
  const dispatch = useDispatch();
  const [searchText, setSearchText] = useState('');

  useEffect(() => {
    dispatch(
      fetchPartnersRequest({
        search_by: 'name',
        search_key: searchText,
        page: 1,
        limit: totalCount,
      }),
    );
  }, [dispatch, searchText, totalCount]);

  return (
    <Autocomplete
      options={partners}
      getOptionLabel={(option) => `${option.name} (${option.email})`}
      onInputChange={(_, newInputValue) => {
        setSearchText(newInputValue);
        if (!newInputValue) {
          onChange(null);
        }
      }}
      onChange={(_, newValue) => {
        onChange(newValue ? newValue._id : null);
      }}
      value={partners.find((part) => part._id === initialValue) || null}
      renderInput={(params) => (
        <TextField
          {...params}
          label="Partner"
          placeholder="Search by Name or Email"
          size="small"
          variant="outlined"
          sx={{ mt: '15px' }}
        />
      )}
      freeSolo
    />
  );
};

export default PartnersSelectField;
